// extracted by mini-css-extract-plugin
module.exports = {"icon":"SectionIcon-module--icon--2XJ5l"};